import { CMSResource } from "app/resources/cmsresource";
import { FooterLinksResource } from "app/models/FooterLinksResource";
import { FooterCellTypeResource } from "app/models/FooterCellTypeResource";

export class FooterCellResource extends CMSResource {

	rid: number;

	footerCellTypeResource: FooterCellTypeResource;

	footerLinksResource: FooterLinksResource[];

	numberOfCells: number;

	active: boolean;

	cellIndex: number;

	titleRo: string;

	titleFr: string;

	titleEn: string;

	titleDe: string;

	imagePath: string;

	imageB64: string;

	orderIndex: number;

	titleFontFamily: string;

	titleFontSize: string;

	columnTopMargin: string;
	userEmail: string
}